import React from "react";
import { Toaster } from "sonner";
import { AppContextProvider } from "./services/context";
import AppRoutes from "./routes/appRoutes";

function App() {
  return (
    <AppContextProvider>
      <Toaster richColors={true} closeButton={true} position="top-center" />
      <AppRoutes />
    </AppContextProvider>
  );
}

export default App;